import { Pill } from '@maas-components/core'
import styled, { css } from 'styled-components'

const getColor = (theme, color) => {
  return `color: ${theme.palette?.getContrastText(color)}; background-color: ${color};`
}

const StatusBullet = styled(Pill)`
  ${({ theme, color }) => css`
    ${color === 'default' && getColor(theme, '#ECECEC')}
    ${color === 'success' && getColor(theme, '#008F2D')}
    ${color === 'warning' && getColor(theme, '#424A52')}
    ${color === 'error' && getColor(theme, '#C70E2A')}
    ${color === 'info' && getColor(theme, '#A400E1')}
    ${color === 'draft' && getColor(theme, '#FCD000')}
  `}
`

StatusBullet.defaultProps = {
  color: 'default',
  variant: 'filled',
}

export default StatusBullet
